/* eslint-disable
    func-names,
    no-shadow,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
// Collection of all Manager.
const deps = ['Person', 'Collection'];
const factory = function (Person, Collection) {
  let ManagerCollection;
  return (ManagerCollection = (function () {
    ManagerCollection = class ManagerCollection extends Collection {
      static initClass() {
        this.prototype.$id = 'manager';

        this.prototype.$resource = 'person';

        this.prototype.$type = Person;
      }

      $url() {
        return `${super.$url()}/manager/`;
      }

      $init() {
        super.$init();

        // Automatically fetch the first time this collection is created.
        if (this.$lastUpdated === 0) {
          return this.$fetch();
        }
      }
    };
    ManagerCollection.initClass();
    return ManagerCollection;
  })());
};

factory.$inject = deps;

const moduleDeps = [require('data/model/person').name, require('data/util').name];

module.exports = angular
  .module('bench.data.collection.manager', moduleDeps)
  .factory('ManagerCollection', factory);
